export default "__VITE_ASSET__BKFHmNb7__"